import { render, staticRenderFns } from "./suspendFromChain.vue?vue&type=template&id=67266858"
import script from "./suspendFromChain.vue?vue&type=script&lang=js"
export * from "./suspendFromChain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports